import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IResponseResult } from 'src/app/models/IResponseResult';
import { ConfigService } from '../config/config.service';
//import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttphelperService {

  baseUrl:string;
  constructor(private http:HttpClient) {
    this.baseUrl = ConfigService.ApiRoot;
  }
  postRequest(url:string,withToken:boolean = false,model:any) : Observable<IResponseResult>
  {
    
    let finalUrl = this.baseUrl + url;   
    if(withToken)
     {        
        let token = localStorage.getItem('token');
        const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
        })
        return this.http.post<IResponseResult>(finalUrl ,model , {headers:headers}).pipe(
          // tap(data => console.log("All Data :" + JSON.stringify(data))),
           catchError(this.handleError)
         );
     }
    else
     {
       return this.http.post<IResponseResult>(finalUrl ,model).pipe(
        // tap(data => console.log("All Data :" + JSON.stringify(data))),
         catchError(this.handleError)
       );
     }    
  }
  getRequest(url:string,withToken:boolean = false):Observable<IResponseResult>
  {
   let finalUrl = this.baseUrl + url;
   
   if(withToken)
   {        
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get<IResponseResult>(finalUrl,{headers:headers}).pipe(
      //tap(data => console.log("All Data :" + JSON.stringify(data))),
      catchError(this.handleError)
    );
   }
   else
   {
    return this.http.get<IResponseResult>(finalUrl).pipe(
      catchError(this.handleError)
    );
   }
   
  }
  private handleError(err:HttpErrorResponse){
    let errorMessage = '';
    if(err.status == 401)
    {
      localStorage.clear();
      window.location.href = 'login';
      return;
    }
    if(err.error instanceof ErrorEvent)
    {
      errorMessage =`an error occurred :${err.error.message}`;
    }
    else
    {
      errorMessage = `Server returned code:${err.status},error message is:${err.message};`
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
